import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import ClientCompanyTypeModal from './ClientCompanyTypeModal';
import ClientCompanyTypeGrid from './ClientCompanyTypeGrid';
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import axios from 'axios';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';
import { logAuditEvent } from '../../utils/auditLogger';

function ClientCompanyTypeMain(props) {
  const [getClientCompanyTypeList, setClientCompanyTypeList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const moduleName = props.Module || 'Client Company Type';
  
  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchClientCompanyType();
  }, [props.Module]);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Client Company Type');
  }, [moduleName]);

  function openAddModal() {
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add client company type modal');
  }
  function closeModal() {
    setIsOpen(false);
  }
  async function onSubmit(e, data) {
    if (e.target.name === "Add") {
      const clientCompanyTypeModel = data;
      if(clientCompanyTypeModel){
        let clientCompanyTypeDetails = {
          ClientCompanyTypeId: null,
          ClientCompanyTypeName: clientCompanyTypeModel.ClientCompanyTypeName ? clientCompanyTypeModel.ClientCompanyTypeName : "",
          Description: clientCompanyTypeModel.Description ? clientCompanyTypeModel.Description : "",
          UserId: getStorageValues('userId')
        };
        if (validation(clientCompanyTypeDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/saveClientCompanyTypeDetails",
              clientCompanyTypeDetails
            );
            if (response.status === 200) {
              if(response.data.data[0].success === 1){
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                fetchClientCompanyType();
                closeModal();
              } else {
                CreateAlert(response.data.data[0].message, "Error", setAlert);
              }
            } 
          } catch (error) {
            console.log(error);
          }
        }
      } else {
        CreateAlert("Fields marked with an asterisk (*) are required!!", "Error", setAlert);
      }
    } 
  }
  function validation(clientCompanyTypeDetails) {
    var validation = true;
    if (clientCompanyTypeDetails) {
      if (clientCompanyTypeDetails.ClientCompanyTypeName !== null | undefined) {
        if (clientCompanyTypeDetails.ClientCompanyTypeName.length === 0) {
          CreateAlert("Please enter client company type!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter client company type!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }
  const fetchClientCompanyType = async () => {
    try {
      let ClientCompanyTypeDetails = {
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/clientCompanyTypelist", ClientCompanyTypeDetails);
      if (response.status === 200) {
        setClientCompanyTypeList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleExportExcel = () => {
    const columns = [
      { name: "Client Company Type", selector: "ClientCompanyTypeName" },
      { name: "Description", selector: "Description" },
    ];
    exportToExcel("ClientCompanyTypes", columns, getClientCompanyTypeList);
  };
  
  const handleExportPDF = () => {
    const columns = [
      { name: "Client Company Type", selector: "ClientCompanyTypeName" },
      { name: "Description", selector: "Description" },
    ];
    exportToPDF("ClientCompanyTypes", columns, getClientCompanyTypeList);
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        onRefresh={fetchClientCompanyType}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <ClientCompanyTypeGrid ClientCompanyTypeData={getClientCompanyTypeList} fetchClientCompanyType={fetchClientCompanyType} UserPermissions={getUserModulePermission} moduleName={moduleName}/>
      <ClientCompanyTypeModal
        show={modalIsOpen}
        UserAction={"Add"}
        onClose={closeModal}
        onSubmit={onSubmit}
        moduleName={moduleName}

      />
    </>
  )
}

export default ClientCompanyTypeMain